import React, {Suspense} from 'react';
// @ts-ignore
import {BrowserRouter, Route, Switch} from 'react-router-dom';
// @ts-ignore
import {Container} from 'shards-react';

import './i18n'
import MainContainer from "./containers/main/MainContainer";
import {RegionSelectedContextProvider} from "./contexts/RegionSelectedContext";

const Router: React.FC = () => {
    const basename = process.env.REACT_APP_BASENAME || '/rankings';
    
    return (
        <BrowserRouter basename={basename}>
            <Suspense fallback={null}>
                <Container fluid style={{height: '100vh'}}>
                    <Switch>
                        <Route exact path={'/'} component={MainContainerWrapper} />
                    </Switch>
                </Container>
            </Suspense>
        </BrowserRouter>
    );
};


export const MainContainerWrapper = () => {
    return (
        <RegionSelectedContextProvider>
            <MainContainer />
        </RegionSelectedContextProvider>
    )
};

export default Router;
